<template>
  <div>
    <div class="switch-calls">
      <v-switch dense label="Ligações em espera?" v-model="showCallsOnWait" />
      <v-dialog v-model="dialogOperadores" width="500" v-if="permissaoAddRemoverOperador">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" class="mr-4">
            <v-icon>mdi-account-plus</v-icon>
          </v-btn>
        </template>

        <v-card>
          <v-card-title>Escolha o operador</v-card-title>
          <v-divider />
          <v-row v-show="showSkeletonDialogOperadores" v-for="n in 2" :key="`skeleton_dialog_operadores_${n}`">
            <v-col>
              <v-skeleton-loader type="list-item" />
            </v-col>
          </v-row>
          <div v-show="!showSkeletonDialogOperadores">
            <div class="mt-4 mx-4">
              <v-autocomplete label="Operador" dense outlined v-model="operadorDialog" :items="operadoresDialog" />
            </div>
            <div class="mt-4 mx-4">
              <v-select label="Prioridade" dense outlined v-model="priorityDialog" :items="prioritiesDialog" />
            </div>
          </div>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn color="primary" text @click="dialogOperadores = false"> Cancelar </v-btn>
            <v-btn color="primary" text @click="addAgenteOnQueue"> Concluir </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogPausas" width="500" v-if="permissaoPausaDespausa">
        <v-card>
          <v-card-title>Escolha a pausa</v-card-title>
          <div class="mt-4 mx-4">
            <v-select label="Pausa" dense outlined v-model="pausaDialog" :items="pausasSelect" />
          </div>
          <v-card-actions>
            <v-spacer />
            <v-btn color="primary" text @click="dialogPausas = false"> Cancelar </v-btn>
            <v-btn color="primary" text @click="pauseUnpauseOperator()"> Concluir </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogSpy" width="500">
        <v-card>
          <v-card-title>Escolha o ramal</v-card-title>
          <div class="mt-4 mx-4">
            <v-autocomplete label="Ramal" dense outlined v-model="ramalDialog" :items="ramaisDialog" />
          </div>
          <v-card-actions>
            <v-spacer />
            <v-btn color="primary" text @click="dialogSpy = false"> Cancelar </v-btn>
            <v-btn color="primary" text @click="emitSpyEvent()"> Concluir </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <v-row no-gutters>
      <v-col>
        <v-row dense class="ml-4">
          <v-card
            class="mr-8 mb-4"
            width="256"
            height="110"
            v-for="(call, key) in operadoresFila"
            :key="key"
            v-show="call.arrayQueues"
          >
            <div :class="`app-bar-card-monitor ${selectColor(call)}`">
              <div class="operator-code-app-bar text-app-bar">
                {{ call.agent.split('-')[1] }}
              </div>

              <div class="operator-name-app-bar text-app-bar">
                {{ call.agent.split('-')[0] }}
              </div>

              <div class="operator-peer-app-bar text-app-bar">
                {{ call.deviceId }}
              </div>

              <div class="operator-priority-app-bar text-app-bar">
                <div class="tooltip">
                  {{ prioridadeFila(call.deviceId) }}
                  <span class="tooltiptext">Prioridade</span>
                </div>
              </div>
            </div>

            <div class="body-card-monitor">
              <div class="pause-or-calls-card-monitor">
                <v-icon
                  @click="prevCall(call.deviceId)"
                  v-show="typeof call.channels !== 'undefined' && verificaLigacoes(call.channels) > 1"
                >
                  mdi-chevron-left
                </v-icon>

                <div class="tooltip time-and-calls-text-card-monitor">
                  {{
                    typeof call.channels !== 'undefined' && verificaLigacoes(call.channels) > 0
                      ? call.channels[call.callIndex].phoneNumber
                      : call.paused === '1'
                      ? limitaNumeroDeCaracteresPausa(call.reason)
                      : ''
                  }}
                  <span
                    class="tooltiptext"
                    v-show="
                      call.paused === '1' &&
                        typeof call.channels !== 'undefined' &&
                        verificaLigacoes(call.channels) === 0
                    "
                    >{{ showPausa(call.reason) }}</span
                  >
                </div>

                <div class="time-and-calls-text-card-monitor">
                  {{
                    typeof call.channels !== 'undefined' && verificaLigacoes(call.channels) > 0
                      ? mostraTempo(call.channels, call.callIndex)
                      : call.time
                  }}
                </div>

                <v-icon
                  @click="nextCall(call.deviceId)"
                  v-show="typeof call.channels !== 'undefined' && verificaLigacoes(call.channels) > 1"
                >
                  mdi-chevron-right
                </v-icon>
              </div>

              <div class="icons-and-calls-card-monitor">
                <div class="qtd-calls-operator-card-body color-icons-qtd-calls-card-body">
                  {{ verificaLigacoes(call.channels) }}
                </div>

                <i
                  v-if="permissaoDeslogarOperador"
                  class="material-icons icon-logout-operator-card-body-monitor color-icons-qtd-calls-card-body"
                  title="Deslogar operador"
                  @click="logoutOperador(call)"
                >
                  logout
                </i>

                <i
                  v-if="permissaoAddRemoverOperador"
                  class="material-icons icon-remove-operator-from-queue-body-monitor color-icons-qtd-calls-card-body"
                  title="Remover Operador da Fila"
                  @click="removeOperadorFromQueue(call)"
                >
                  close
                </i>

                <i
                  v-if="permissaoOuvirLigacao"
                  class="material-icons icon-hear-call-card-body color-icons-qtd-calls-card-body"
                  title="Ouvir"
                  @click="ouvirLigacao(call.channels, call.callIndex)"
                  v-show="typeof call.channels !== 'undefined' && verificaLigacoes(call.channels) > 0"
                >
                  volume_up
                </i>

                <i
                  v-if="permissaoPausaDespausa"
                  class="material-icons icon-pause-unpause-operator-card-body-monitor color-icons-qtd-calls-card-body"
                  :title="call.paused === '0' ? 'Pausar Operador' : 'Despausar Operador'"
                  @click="call.paused === '0' ? abreDialogPausa(call) : pauseUnpauseOperator(call)"
                >
                  {{ call.paused === '0' ? 'pause' : 'play_arrow' }}
                </i>

                <i
                  class="material-icons icon-operator-card-body color-icons-qtd-calls-card-body"
                  v-show="typeof call.channels !== 'undefined' && verificaLigacoes(call.channels) > 0"
                >
                  {{
                    typeof call.channels !== 'undefined' &&
                      verificaLigacoes(call.channels) > 0 &&
                      selectItem(call.channels, call.callIndex)
                  }}
                </i>
                <div
                  class="show-queue-card-body-monitor color-icons-qtd-calls-card-body"
                  v-show="typeof call.channels !== 'undefined' && verificaLigacoes(call.channels) > 0"
                >
                  <div class="tooltip">
                    {{
                      call.queueEnters && call.queueEnters.length > 0
                        ? mostraFila(call.channels, call.callIndex, call.queueEnters)
                        : ''
                    }}
                    <span class="tooltiptext">{{ filaCompleta(call.channels, call.callIndex) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </v-card>
        </v-row>
      </v-col>
      <v-col cols="3" v-show="showCallsOnWait">
        <v-card outlined height="220">
          <v-app-bar color="grey lighten-2" dense flat>
            <!-- <div class="text-subtitle-2 font-weight-bold text-uppercase black--text"> -->
            <div class="text-subtitle-2 font-weight-bold text-uppercase">
              Chamadas em Espera - {{ getCallsOnWaitByQueue(idFila).length }}
            </div>
          </v-app-bar>

          <div class="body-calls">
            <div
              class="ligacoes-pendentes"
              v-for="callOnWait in getCallsOnWaitByQueue(idFila)"
              :key="`ligacao_em_espera_${callOnWait.linkedId}`"
            >
              <div class="ml-2 font-italic text-subtitle-2">{{ callOnWait.origin }}</div>
              <div class="mr-2 font-italic text-subtitle-2 text-right font-weight-bold">
                {{ callOnWait.time }}
              </div>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'
import { obtainUserPermissions } from '@/utils/obtainUserPermissions'

import monitorRamaisCallCenter from '../_store'
import { monitorRamaisCallCenterMethods } from '../_utils/monitorRamaisCallCenterMethods'
import {
  arrayPermissaoPausaDespausa,
  arrayPermissaoAdicionarRemover,
  arrayPermissaoDeslogarOperador,
  arrayPermissaoOuvirOperador,
} from '../_utils/arraysPermissionsMonitorFilas'

export default {
  name: 'MonitorRamaisCallCenter',
  props: {
    idFila: String,
  },

  data: () => ({
    ramaisFiltrados: [],
    prioritiesDialog: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    priorityDialog: '1',
    aguarde: false,
    loader: null,
    moment: moment,
    operatorTime: [],
    operadores: [],
    showCallsOnWait: true,
    dialogOperadores: false,
    showSkeletonDialogOperadores: false,
    operadoresDialog: [],
    operadorDialog: '',
    dialogPausas: false,
    pausasDialog: [],
    pausaDialog: '',
    pausasSelect: [],
    agentSelected: {},
    dialogSpy: false,
    ramaisDialog: [],
    ramalDialog: '',
    channelOuvido: '',
    permissaoPausaDespausa: false,
    permissaoAddRemoverOperador: false,
    permissaoDeslogarOperador: false,
    permissaoOuvirLigacao: false,
    filas: [],
    user: [],
  }),
  computed: {
    ...mapGetters(['getRamais', 'getCallsOnWaitByQueue']),
    ...mapGetters('monitorRamaisCallCenter', [
      'getPausas',
      'getRamaisState',
      'getFilas',
      'getPermission',
      'getOperadores',
    ]),

    operadoresFila() {
      let retornoOperadoresFila = []
      this.getRamais.forEach(ramal => {
        if (typeof ramal.arrayQueues !== 'undefined') {
          const indexQueue = ramal.arrayQueues.findIndex(idQueue => idQueue.queue === this.idFila)

          if (indexQueue !== -1) {
            retornoOperadoresFila.push(Object.assign({}, ramal))
          }
        }
      })
      return retornoOperadoresFila
    },
  },

  async created() {
    registerVuexModule(this.$store, 'monitorRamaisCallCenter', monitorRamaisCallCenter)

    const arrayPermissions = this.arrayPermissionsFromLocalStorage()

    arrayPermissions.forEach(permissionLocalStorage => {
      if (arrayPermissaoPausaDespausa.includes(permissionLocalStorage)) {
        this.permissaoPausaDespausa = true
      }
      if (arrayPermissaoAdicionarRemover.includes(permissionLocalStorage)) {
        this.permissaoAddRemoverOperador = true
      }
      if (arrayPermissaoDeslogarOperador.includes(permissionLocalStorage)) {
        this.permissaoDeslogarOperador = true
      }
      if (arrayPermissaoOuvirOperador.includes(permissionLocalStorage)) {
        this.permissaoOuvirLigacao = true
      }
    })

    await Promise.all([this.listarPausas(), this.listarFilas(), this.listarRamais()])

    this.filas = this.getFilas.map(fila => ({ _id: fila._id, description: fila.description }))
    this.pausasDialog = this.getPausas.map(pausa => ({ text: pausa.description, value: pausa._id }))
    if(this.pausasDialog.length > 0){
      this.pausasSelect = this.pausasDialog.filter(( pausa ) => pausa.text !== 'autopause' );
    }
    this.ramaisDialog = this.getRamaisState.map(ramal => ({ text: ramal.numero, value: ramal.numero }))
    this.user = this.getRamaisState.map(ramal => ({ peer: ramal.numero, user: ramal.usuario }))
  },

  methods: {
    ...mapActions(['prevCall', 'nextCall']),
    ...mapActions('monitorRamaisCallCenter', [
      'listarPausas',
      'listarFilas',
      'listarRamais',
      'obterPermissao',
      'listarOperadores',
    ]),
    ...obtainUserPermissions,
    ...monitorRamaisCallCenterMethods,
  },

  watch: {
    dialogOperadores: {
      deep: true,
      immediate: true,
      async handler() {
        this.operadoresDialog = []
        if (this.dialogOperadores) {
          this.showSkeletonDialogOperadores = true

          await this.listarOperadores()

          this.getRamais.forEach(ramal => {
            if ((ramal.paused === '0' || ramal.paused === false) && ramal.agent) {
              const indexOperadorNaoPausado = this.getOperadores.findIndex(
                operador => `${operador.usuario}-${operador.numero}` === ramal.agent
              )
              if (indexOperadorNaoPausado !== -1) {
                this.operadoresDialog.push({
                  text: `${this.getOperadores[indexOperadorNaoPausado].numero} - ${this.getOperadores[indexOperadorNaoPausado].usuario}`,
                  value: this.getOperadores[indexOperadorNaoPausado].numero,
                })
              }
            }
          })

          this.operadoresFila.forEach(operadorFila => {
            const indexOperadorDialog = this.operadoresDialog.findIndex(
              operadorDialog =>
                operadorDialog.text ===
                operadorFila.agent
                  .split('-')
                  .reverse()
                  .join(' - ')
            )
            if (indexOperadorDialog !== -1) {
              this.operadoresDialog.splice(indexOperadorDialog, 1)
            }
          })
          this.showSkeletonDialogOperadores = false
        }
      },
    },
  },
}
</script>

<style scoped>
.app-bar-card-monitor {
  position: relative;
  width: 256px;
  height: 40px;
}

.app-bar-card-monitor-background-color-green {
  background-color: green;
}

.app-bar-card-monitor-background-color-yellow {
  background-color: #FBC400;
}

.app-bar-card-monitor-background-color-orange {
  background-color: var(--v-orangePcm-base);
}

.app-bar-card-monitor-background-color-red {
  background-color: var(--v-darkRed-base);
}

.app-bar-card-monitor-background-color-grey {
  background-color: var(--v-lightGray-base);
}

.text-app-bar {
  font-size: 13px;
  font-weight: bold;
  color: var(--v-white-base);
}

.operator-code-app-bar {
  position: absolute;
  top: 0;
  left: 4px;
}

.operator-name-app-bar {
  position: absolute;
  bottom: 0;
  left: 4px;
}

.operator-peer-app-bar {
  position: absolute;
  top: 0;
  right: 4px;
}

.operator-priority-app-bar {
  position: absolute;
  bottom: 0;
  right: 4px;
}

.body-card-monitor {
  position: relative;
  width: 256px;
  height: 55px;
}

.pause-or-calls-card-monitor {
  margin: 16px -12px 0;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
}

.time-and-calls-text-card-monitor {
  color: var(--v-monitorText-base);
  font-style: italic;
  font-size: 14px;
}

.icons-and-calls-card-monitor {
  width: 100%;

  display: flex;
  flex-direction: row-reverse;
  align-items: flex-end;

  position: absolute;
  bottom: 0;
  right: 0;
}

.color-icons-qtd-calls-card-body {
  color: var(--v-darkGray-base);
  font-size: 17px;
}

.show-queue-card-body-monitor {
  margin: 0 auto 5px 4px;

  font-style: italic;
  font-size: 14px;
}

.qtd-calls-operator-card-body {
  margin-right: 4px;
}

.icon-logout-operator-card-body-monitor {
  margin-right: 4px;
  margin-bottom: 5px;
}

.icon-logout-operator-card-body-monitor:hover {
  cursor: pointer;
}

.icon-remove-operator-from-queue-body-monitor {
  margin-right: 4px;
  margin-bottom: 5px;
}

.icon-remove-operator-from-queue-body-monitor:hover {
  cursor: pointer;
}

.icon-pause-unpause-operator-card-body-monitor {
  margin-right: 4px;
  margin-bottom: 5px;
}

.icon-pause-unpause-operator-card-body-monitor:hover {
  cursor: pointer;
}

.icon-hear-call-card-body {
  margin-right: 4px;
  margin-bottom: 5px;
}

.icon-hear-call-card-body:hover {
  cursor: pointer;
}

.icon-operator-card-body {
  margin-right: 4px;
  margin-bottom: 5px;
}

.tooltip {
  position: relative;
  display: inline-block;
}

.tooltip .tooltiptext {
  visibility: hidden;
  background-color: rgba(85, 85, 85, 0.504);
  color: var(--v-white-base);
  font-weight: bold;
  text-align: center;
  padding: 2px 8px;
  white-space: nowrap;
  border-radius: 6px;

  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -30px;

  opacity: 0;
  transition: opacity 0.3s;
}

.tooltip .tooltiptext::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: rgba(85, 85, 85, 0.504) transparent transparent transparent;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}

.switch-calls {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  margin-bottom: -16px;
  margin-top: -12px;
}

.ligacoes-pendentes {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  margin-left: 8px;
  margin-right: 8px;
  margin-top: 4px;
}
.body-calls {
  overflow: auto;
  max-height: 170px;
}
</style>
